import { logger } from "@/lib/logging";

function loadDeferredIntegrations(): void {
  void import("./tracing")
    .then(({ attachTracingIntegration }) => {
      attachTracingIntegration();
    })
    .catch((error: unknown) => {
      logger.warn({ err: error }, "[sentry] tracing load failed");
    });
  void import("./replay")
    .then(({ attachReplayIntegration }) => {
      attachReplayIntegration();
    })
    .catch((error: unknown) => {
      logger.warn({ err: error }, "[sentry] replay load failed");
    });
}

function loadDeferredIntegrationsWhenIdle(): void {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadDeferredIntegrations, { timeout: 3_000 });
    return;
  }
  globalThis.setTimeout(loadDeferredIntegrations, 0);
}

/** Attach optional Sentry performance and replay instrumentation after page load. */
export function scheduleDeferredIntegrations(): void {
  if (document.readyState === "complete") {
    loadDeferredIntegrationsWhenIdle();
    return;
  }
  window.addEventListener("load", loadDeferredIntegrationsWhenIdle, { once: true });
}
